const img = document.querySelector(".first");
img.addEventListener("mouseover", () => {
    img.classList.add("scale");
});
